import { createVNode as a, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ToBottomFilledStandard.js";
import m from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(m, d(e, {
    icon: l
  }), null);
};
t.displayName = "ToBottomFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
